export default __webpack_public_path__ + "static/media/1.4c5ceb32.jpg";